<template>
  <v-dialog :value="value" max-width="440px" persistent @input="$emit('input', $event)">
    <v-card class="pa-6 guest-booking-dialog" rounded="xl" v-if="option">
      <div class="d-flex align-center justify-space-between mb-5">
        <span class="guest-booking-dialog__title">Запись на диагностику</span>
        <v-btn icon outlined small class="guest-booking-dialog__close" @click="close">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-0">
        <div class="guest-booking-dialog__summary mb-5">
          <div class="d-flex align-center mb-3">
            <v-avatar size="40" color="#483CB9" class="mr-3">
              <img v-if="option.expert.photo_url" :src="option.expert.photo_url" :alt="expertName">
              <span v-else class="white--text text-caption">{{ initials(expertName) }}</span>
            </v-avatar>
            <div>
              <div class="text-body-2 font-weight-bold">{{ expertName }}</div>
              <div class="text-caption grey--text">{{ option.service_type.name }}</div>
            </div>
          </div>
          <div class="guest-booking-dialog__datetime">
            <v-icon size="16" color="#483CB9" class="mr-1">mdi-calendar-outline</v-icon>{{ dateLabel }}
            <v-icon size="16" color="#483CB9" class="mr-1 ml-3">mdi-clock-outline</v-icon>{{ timeLabel }}
          </div>
        </div>

        <div class="text-caption grey--text text--darken-1 mb-1">Имя</div>
        <v-text-field v-model="form.guest_first_name" outlined dense hide-details class="mb-3" />

        <div class="text-caption grey--text text--darken-1 mb-1">Фамилия</div>
        <v-text-field v-model="form.guest_last_name" outlined dense hide-details class="mb-3" />

        <div class="text-caption grey--text text--darken-1 mb-1">Email</div>
        <v-text-field v-model="form.guest_email" outlined dense hide-details type="email" class="mb-3" />

        <div class="text-caption grey--text text--darken-1 mb-1">Telegram (необязательно)</div>
        <v-text-field v-model="form.telegram_username" outlined dense hide-details placeholder="@username" class="mb-2" />

        <v-alert v-if="error.length" type="error" dense text rounded="lg" class="mt-3 mb-0">
          Не удалось создать запись. Возможно, это время уже занято — попробуйте выбрать другое.
        </v-alert>
      </v-card-text>

      <v-card-actions class="pa-0 mt-5">
        <v-btn block height="44" rounded color="#483CB9" :dark="canSubmit" :loading="loading" :disabled="!canSubmit" @click="submit">
          Записаться
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { utcToLocalDate, utcToLocalTime } from '@/common/calendarTime';

export default {
  name: 'GuestBookingDialog',
  props: {
    value: { type: Boolean, default: false },
    option: { type: Object, default: null }, // AvailabilityOption
    loading: { type: Boolean, default: false },
    error: { type: Array, default: () => [] },
    // Контакты из прошлой неудачной попытки (409 — время заняли/вариант исключён ссылкой):
    // гость выбирает другое время, а вводить данные заново не нужно.
    initialContacts: { type: Object, default: null },
  },
  data() {
    return {
      form: this.buildForm(),
    };
  },
  computed: {
    expertName() {
      if (!this.option || !this.option.expert) return '';
      return `${this.option.expert.first_name || ''} ${this.option.expert.last_name || ''}`.trim();
    },
    dateLabel() {
      if (!this.option) return '';
      return this.$moment(utcToLocalDate(this.option.starts_at), 'YYYY-MM-DD').locale('ru').format('D MMMM YYYY');
    },
    timeLabel() {
      if (!this.option) return '';
      return `${utcToLocalTime(this.option.starts_at)} – ${utcToLocalTime(this.option.ends_at)}`;
    },
    canSubmit() {
      return Boolean(this.form.guest_first_name && this.form.guest_last_name && this.form.guest_email);
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) this.form = this.buildForm();
    },
  },
  methods: {
    buildForm() {
      const contacts = this.initialContacts || {};
      return {
        guest_first_name: contacts.guest_first_name || '',
        guest_last_name: contacts.guest_last_name || '',
        guest_email: contacts.guest_email || '',
        telegram_username: contacts.telegram_username || '',
      };
    },
    initials(name) {
      return name.split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
    },
    close() {
      this.$emit('input', false);
    },
    submit() {
      if (!this.canSubmit || !this.option) return;
      this.$emit('submit', {
        availability_id: this.option.availability_id,
        service_id: this.option.service_id,
        starts_at: this.option.starts_at,
        guest_first_name: this.form.guest_first_name,
        guest_last_name: this.form.guest_last_name,
        guest_email: this.form.guest_email,
        telegram_username: this.form.telegram_username,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_tokens.scss';

.guest-booking-dialog {
  &__title {
    font-size: $text-lg;
    font-weight: $weight-semibold;
    color: #483CB9;
  }

  &__close {
    border-color: #e0dff5;
  }

  &__summary {
    background: #F7F6FB;
    border-radius: $radius-md;
    padding: $space-4;
  }

  &__datetime {
    font-size: $text-xs;
    color: #6b6f7a;
    display: flex;
    align-items: center;
  }

  ::v-deep .v-text-field .v-input__slot fieldset {
    border-radius: $radius-sm;
  }
}
</style>
